package app.view

import app.CustomRouter
import app.Routes
import app.api.ProjectApi
import app.components.sidebarNavigation
import app.utils.formatDateTime
import app.utils.getLightStatusBackgroundColor
import dev.fritz2.core.*

fun RenderContext.projectDetailView(
    projectApi: ProjectApi,
    projectId: String?,
) {
    if (projectId == null) {
        CustomRouter.navTo(mapOf("route" to Routes.PROJECTS))
        return
    }

    projectApi.handler(projectId)
    projectApi.data.render { project ->
        if (project != null) {
            div("flex gap-4 dark:text-white") {
                sidebarNavigation(projectId)
                div("basis-10/12 border rounded-md shadow-md my-4 p-4 group dark:bg-gray-800 dark:border-gray-700") {
                    div("mb-4") {
                        div("flex") {
                            p("text-xl") {
                                +project.name
                            }
                        }
                        if (project.description != null) {
                            p("text-sm") {
                                +project.description
                            }
                        }
                    }
                    div("flex flex-col gap-4") {
                        project.companyProjects.forEach { company ->
                            div("flex flex-row gap-4 items-start") {
                                div("w-40 group/companyproject") {
                                    div("border rounded-lg h-20 dark:border-gray-700 dark:bg-gray-800") {
                                        div("flex font-semibold p-2") {
                                            p("font-semibold") {
                                                +company.name
                                            }
                                        }
                                    }
                                }
                                div("flex flex-row gap-4 overflow-x-auto") {
                                    company.stages.sortedBy { it.ordering }.forEach { stage ->
                                        button(
                                            "w-40 border rounded-lg h-20 flex relative group/stageId dark:border-gray-700 " +
                                                    getLightStatusBackgroundColor(stage.latestRolloutExecution)
                                        ) {
                                            disabled(stage.latestRolloutExecution == null)
                                            clicks handledBy {
                                                CustomRouter.rollout(
                                                    mapOf(
                                                        "route" to Routes.ROLLOUT,
                                                        Routes.Params.PROJECT_ID to projectId,
                                                        Routes.Params.ROLLOUT_ID to stage.latestRolloutExecution?.id.toString(),
                                                    )
                                                )
                                            }
                                            div("flex p-1 h-min w-full") {
                                                p("font-semibold") { +stage.name }
                                            }
                                            p("text-xs absolute right-0 bottom-0 p-1") {
                                                if (stage.latestRolloutExecution != null) {
                                                    div("flex flex-col") {
                                                        div("ml-auto text-sm font-semibold") {
                                                            +"${stage.latestRolloutExecution.version}"
                                                        }
                                                        div {
                                                            +formatDateTime(stage.latestRolloutExecution.startedAt)
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
